export default __webpack_public_path__ + "static/media/global-footprint-Header-4k.4d439f4c.jpg";